import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import { useToastSharePhotos } from './ToastSharePhotos.logic';
import { style } from './ToastSharePhotos.style';
import TextLato from '../text/text-lato/TextLato';
import { SecondaryButton } from '../buttons/secondary-button/SecondaryButton';
import { PrimaryButton } from '../buttons/primary-button/PrimaryButton';
import { FocusGroups } from '../focus-provider/FocusProvider.constants';
import { PhotosContainer } from '../photos-container/PhotosContainer';

export const ToastSharePhotos = observer(() => {
  const { i18n, data, onPressConfirm, onPressDecline } = useToastSharePhotos();
  return (
    <View style={style.container} testID="marco-test">
      <PhotosContainer urls={data.notificationFiles.map(file => file.thumbnailUrl)} />
      <View style={style.content}>
        <View style={style.textContainer}>
          <TextLato style={style.title}>{i18n.t('toast-share-photos:title')}</TextLato>
          <TextLato style={style.description}>{i18n.t('toast-share-photos:description')}</TextLato>
        </View>
        <View style={style.ctaContainer}>
          <SecondaryButton
            onPress={onPressDecline}
            style={{ minHeight: 30, height: 30 }}
            text={i18n.t('toast-share-photos:cta-decline')}
            focusGroup={FocusGroups.TOAST_NOTIFICATION}
            focusId=""
            focusOrder={0}
          />
          <PrimaryButton
            onPress={onPressConfirm}
            style={{ minHeight: 30, height: 30 }}
            text={i18n.t('toast-share-photos:cta-confirm')}
            focusGroup={FocusGroups.TOAST_NOTIFICATION}
            focusId=""
            focusOrder={1}
          />
        </View>
      </View>
    </View>
  );
});
